var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.has_settings)?_c('div',{staticClass:"filter-price-range"},[_c('div',{staticClass:"filter-price-range__labels"},[_c('span',[_vm._v(_vm._s(_vm.format_price(_vm.current_min)))]),_c('span',[_vm._v(" - ")]),_c('span',[_vm._v(_vm._s(_vm.format_price(_vm.current_max)))])]),_c('vb-range-slider',{key:_vm.slider_key,attrs:{"vb_options":{
      items: _vm.filter_price_settings.values,
      inputs: false,
      min: _vm.filter_price_range.min !== undefined ? _vm.filter_price_range.min : _vm.filter_price_settings.min,
      max: _vm.filter_price_range.max !== undefined ? _vm.filter_price_range.max : _vm.filter_price_settings.max,
      min_angle: _vm.filter_price_settings.min,
      max_angle: _vm.filter_price_settings.max,
    }},on:{"change":_vm.on_change}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }